import axios from './axios.client';

// Get all opportunities
export const getOpportunities = async () => {
  const response = await axios.get('/opportunities');
  return response.data;
};

// Get opportunity by ID
export const getOpportunity = async (id) => {
  const response = await axios.get(`/opportunities/${id}`);
  return response.data;
};

// Create new opportunity
export const createOpportunity = async (opportunityData) => {
  const response = await axios.post('/opportunities', opportunityData);
  return response.data;
};

// Update opportunity
export const updateOpportunity = async (id, opportunityData) => {
  const response = await axios.put(`/opportunities/${id}`, opportunityData);
  return response.data;
};

// Delete opportunity
export const deleteOpportunity = async (id) => {
  const response = await axios.delete(`/opportunities/${id}`);
  return response.data;
};

// Upload opportunities from CSV
export const uploadOpportunities = async (formData) => {
  const response = await axios.post('/opportunities/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Extract fields from voice input using NLP
export const extractOpportunityFields = async (transcript, provider = 'ollama') => {
  const response = await axios.post('/opportunities/extract-fields', {
    transcript,
    provider,
  });
  return response.data;
};
